<template>
  <div>
    <q-dialog 
      :visible="isVisible"
      title="新增商户号配置"
      width="600px"
      :innerScroll="false"
      :offsetHeight="170"
      @close="onCancel"
      @cancel="onCancel"
      @confirm="onConfirm"
    >
      <el-form :model="formData" :rules="rules" ref="ruleForm" size="small" label-width="120px">
        <el-form-item label="经销商名称" prop="customerId">
          <el-input class="input-box" disabled v-if="isEdit" v-model="formData.customerName"></el-input>
          <el-select
            v-else
            class="input-box" 
            filterable 
            remote 
            v-model="formData.customerId" 
            placeholder="请选择经销商名称"
            :remote-method="queryCustomers"
            :loading="loading"
            @change="changeCustomer"
          >
            <el-option 
              :label="item.customerName" :value="item.customerId" 
              v-for="(item,index) in customerNameOptions"
              :key="index"
            />
          </el-select>
         
        </el-form-item>
        <el-form-item label="主体类型" prop="regMerType">
          <el-select class="input-box" v-model="formData.regMerType" placeholder="请选择主体类型">
            <el-option 
              :label="item.label" 
              :value="item.value" 
              v-for="(item,index) in regMerTypeOptions" 
              :key="index"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="商户名称" prop="shopName">
          <el-input class="input-box" v-model="formData.shopName"></el-input>
        </el-form-item>
        <el-form-item label="商户号" prop="merNo">
          <el-input class="input-box" :disabled="isEdit" v-model="formData.merNo"></el-input>
        </el-form-item>
        <el-form-item label="代付编码" prop="merNoWithdraw">
          <el-input class="input-box" :disabled="isEdit" v-model="formData.merNoWithdraw"></el-input>
        </el-form-item>
        <el-form-item label="法人" prop="legalName">
          <el-input class="input-box" v-model="formData.legalName"></el-input>
        </el-form-item>
        <el-form-item label="统一信用代码" prop="shopLic">
          <el-input class="input-box" v-model="formData.shopLic"></el-input>
        </el-form-item>
        <el-form-item label="银行卡号" prop="bankNo">
          <el-input class="input-box" v-model="formData.bankNo"></el-input>
        </el-form-item>
        <el-form-item label="开户银行全称" prop="bankName">
          <el-input class="input-box" v-model="formData.bankName"></el-input>
        </el-form-item>
      </el-form> 
    </q-dialog>
  </div>
</template>

<script>
export default {
  props: {
    isShowAddDialog: {
      type: Boolean,
      default: false
    },
    changePayWayParams: {
      type: Object,
      default() {
        return {}
      }
    },
    isEdit: {
      type: Boolean,
      default: false
    },
    newAddData: {
      type: Object,
      default() {
        return {}
      } 
    }
  },
  computed: {
    isVisible: {
      get() {
        return this.isShowAddDialog
      },
      set(newVal) {
        this.$emit('update:isShowAddDialog',newVal)
      }
    },
    formData: {
      get() {
        console.log(this.newAddData)
        return this.newAddData
      },
      set(newVal) {
        this.$emit('update:newAddData',newVal)
      }
    }
  },
  data() {
    return {
      rules: {
        customerId: [
          { required: true, message: '请选择经销商名称', trigger: 'change' },
        ],
        regMerType: [
          { required: true, message: '请选择主体类型', trigger: 'change' },
        ],
        shopName: [
          { required: true, message: '请输入商户名称', trigger: 'blur' },
        ],
        merNo: [
          { required: true, message: '请输入商户号', trigger: 'blur' },
        ],
        merNoWithdraw: [
          { required: true, message: '请输入代付编码', trigger: 'blur' },
        ],
        legalName: [
          { required: true, message: '请输入法人', trigger: 'blur' },
        ],
        shopLic: [
          { required: true, message: '请输入统一信用代码', trigger: 'blur' },
        ],
        bankNo: [
          { required: true, message: '请输入银行卡号', trigger: 'blur' },
        ],
        bankName: [
          { required: true, message: '请输入开户银行全称', trigger: 'blur' },
        ],
      },
      regMerTypeOptions: [
        { label: "企业商户", value: "00" },
        { label: "个体工商户", value: "01" },
        { label: "小微商户", value: "02" }
      ],
      customerNameOptions: [],
      loading: false,
    }
  },
  mounted() {
    if (!this.isEdit) {
      this.queryCustomers()
    }
  },
  methods: {
    onCancel() {
      this.isVisible = false
      this.$refs.ruleForm.resetFields();
    },
    queryCustomers(customerName = '') {
      this.loading = true
      this.$api.configure.queryCustomers({
        filterData: {
          customerName: customerName,
        },
        pageNum: 1,
        pageSize: 500
      }).then(res => {
        if (res.success && res.data && res.data.list) {
          this.customerNameOptions = res.data.list || []
        }
      }).finally(() => {
        this.loading = false 
      })
    },
    changeCustomer(customerId) {
      const findItem = this.customerNameOptions.find(item => item.customerId == customerId )
      if (findItem) {
        this.formData.customerName = findItem.customerName || ''
      } else {
        this.formData.customerName = ''
      }
    },
    onConfirm() {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          this.$api.configure.addOrEditUnionOfflineCustomer(this.formData).then(res => {
            if (res.success) {
              this.$message.success("保存成功");
              this.onCancel()
              this.$emit('addSuccess')
            } 
          })
        } 
      });
    }
  }
}
</script>
<style lang="stylus" scoped>
  .input-box {
    width: 360px;
  }
</style>
